import { z } from 'zod';

export const LookupZipParamsSchema = z.object({
  zip: z.string().trim().min(8),
});

export type LookupZipParams = z.infer<typeof LookupZipParamsSchema>;

export const LookupZipResponseSchema = z.object({
  zipCodeNormalized: z.string(),
  street: z.string().nullable(),
  neighborhood: z.string().nullable(),
  cityName: z.string(),
  stateCode: z.string(),
  municipalCode: z.string().nullable().optional(),
  ibgeCode: z.string().nullable().optional(),
  stateId: z.uuid().optional(),
  cityId: z.uuid().optional(),
  source: z.literal('viacep'),
  fetchedAt: z.iso.datetime(),
});

export type LookupZipResponse = z.infer<typeof LookupZipResponseSchema>;
